import { CAST_AI } from '@cast/constants';

import { useFeatureProgressItems } from './useFeatureProgressItems';
import {
  EnablingStepLayout,
  ConnectionProgressRow,
  WhatHappensNextBullet,
  WhatHappensNextSection,
} from '../../../../../_components/new-onboarding';

type Props = {
  onClose: () => void;
  onBack: () => void;
};

export const EnablingCastAiSlide = ({ onClose, onBack }: Props) => {
  const featureItems = useFeatureProgressItems();

  return (
    <EnablingStepLayout
      onBack={onBack}
      onClose={onClose}
      testId="enabling-features-step"
      title={`Enabling ${CAST_AI} features`}
    >
      <WhatHappensNextSection>
        <WhatHappensNextBullet>
          {CAST_AI} components will be deployed to your cluster
        </WhatHappensNextBullet>
        {featureItems.map((item) => (
          <ConnectionProgressRow key={item.key} item={item} />
        ))}
        <WhatHappensNextBullet>
          Data collection will begin within 5 minutes
        </WhatHappensNextBullet>
        <WhatHappensNextBullet>
          Product recommendations will appear in 15-30 minutes
        </WhatHappensNextBullet>
      </WhatHappensNextSection>
    </EnablingStepLayout>
  );
};
